import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, Coins, TrendUp, ArrowRight } from '@phosphor-icons/react';

export const ContractorLeadsCTA = ({ leadsData }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-gradient-to-r from-orange-500 to-amber-500 border-2 border-black rounded-xl p-6 shadow-[4px_4px_0px_#000] mb-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center border-2 border-white/30">
            <ShoppingCart size={32} weight="bold" className="text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white">Leads Marketplace</h2>
            <p className="text-white/80">Find new clients in your area</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-6 bg-white/10 rounded-lg px-4 py-2 border border-white/20">
            <div className="text-center">
              <p className="text-2xl font-bold text-white">{leadsData.available}</p>
              <p className="text-xs text-white/70 uppercase">Available</p>
            </div>
            <div className="w-px h-8 bg-white/30"></div>
            <div className="text-center">
              <p className="text-2xl font-bold text-white">{leadsData.purchased}</p>
              <p className="text-xs text-white/70 uppercase">Purchased</p>
            </div>
            <div className="w-px h-8 bg-white/30"></div>
            <div className="text-center flex flex-col items-center">
              <div className="flex items-center gap-1">
                <Coins size={18} weight="bold" className="text-white" />
                <p className="text-2xl font-bold text-white">{leadsData.credits}</p>
              </div>
              <p className="text-xs text-white/70 uppercase">Credits</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/leads-marketplace')}
            className="flex items-center gap-2 h-12 px-6 bg-white text-orange-600 font-bold rounded-lg border-2 border-black shadow-[3px_3px_0px_#000] hover:shadow-[4px_4px_0px_#000] active:translate-y-1 active:shadow-none transition-all"
            data-testid="browse-leads-btn"
          >
            <TrendUp size={20} weight="bold" />
            Browse Leads
            <ArrowRight size={18} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
};
